/**
 * PostHog reverse-proxy toggle. Ad blockers silently drop 10-25% of direct
 * browser events; routing them through our own domain recovers them.
 *
 * Enabled by setting NEXT_PUBLIC_POSTHOG_PROXY=1 (build-time: flip the Vercel
 * env var and redeploy). Off by default so it can be switched off if Vercel
 * bandwidth/request usage becomes an issue.
 *
 * Consumers:
 * - next.config.mjs — rewrites `${POSTHOG_PROXY_PATH}/*` to PostHog Cloud
 * - src/lib/analytics/PosthogAnalytics.ts — points posthog-js at the path
 * - src/proxy.ts — the middleware matcher EXCLUDES this path as a hardcoded
 *   string (Next requires a static matcher); update it too if renaming.
 *
 * Deliberately innocuous path — blocklists target names like /ingest.
 */
export const POSTHOG_PROXY_PATH = "/relay";

/**
 * Coerce at use site: env.mjs skips zod validation on CI/Vercel, so the env
 * value reaches consumers as a raw string there (boolean only in local dev).
 *
 * @param {unknown} value
 * @returns {boolean}
 */
export const isPosthogProxyEnabled = (value) =>
  value === true || value === "1" || value === "true";
